import React from "react";
import { Table, Avatar, Tag, Dropdown } from "antd";
import { MoreOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { getStatus } from "./IterationCard";
import { useNavigate } from "react-router-dom";

// Colors for iteration status
const statusColors = {
  active: "#D1FAE5",
  COMPLETED: "#F3F4F6",
  archived: "#FEE2E2",
};

const IterationsTableView = ({
  iterations,
  projectId,
  openEditDrawer,
  setIterationToDelete,
  onDelete,
}) => {
  const navigate = useNavigate();
  const columns = [
    {
      title: "Iteration",
      dataIndex: "name",
      key: "name",
      width: 250,
      render: (name, record) => (
        <a
          onClick={() =>
            navigate(`/general/projects/${projectId}/iterations/${record.id}`)
          }
        >
          {name}
        </a>
      ),
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: 120,
    },
    {
      title: "Key",
      dataIndex: "key",
      key: "key",
      width: 150,
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      width: 120,
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
      width: 120,
    },
    {
      title: "Tasks",
      dataIndex: "tasks",
      key: "tasks",
      width: 80,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 120,
      render: (status, record) => (
        <span
          style={{
            background: statusColors[status] || "#F3F4F6",
            color: "#000",
            padding: 4,
            paddingInline: 8,
            borderRadius: 4,
          }}
        >
          {getStatus(record.startDate, record.endDate)}
        </span>
      ),
    },
    {
      title: "",
      key: "actions",
      width: 60,
      align: "right",
      render: (_, record) => {
        const items = [
          {
            key: "edit",
            icon: <EditOutlined />,
            label: "Edit",
            onClick: ({ domEvent }) => {
              domEvent.stopPropagation();
              openEditDrawer(record);
            },
          },
          {
            key: "delete",
            icon: <DeleteOutlined />,
            label: "Delete",
            danger: true,
            onClick: ({ domEvent }) => {
              domEvent.stopPropagation();
              onDelete?.(record);
            },
          },
        ];

        return (
          <Dropdown
            menu={{ items }}
            trigger={["click"]}
            placement="bottomRight"
          >
            <MoreOutlined
              style={{ fontSize: 16, cursor: "pointer", color: "#6b7280" }}
              onClick={(e) => e.stopPropagation()}
            />
          </Dropdown>
        );
      },
    },
  ];

  return (
    <div className="iterations-list-view">
      <Table
        columns={columns}
        dataSource={iterations}
        rowKey="id"
        pagination={{ pageSize: 10 }}
        expandable={{
          expandedRowRender: (record) => (
            <div
              style={{
                padding: 12,
                background: "#f9fafb",
                display: "flex",
                flexDirection: "column",
                gap: 12,
              }}
            >
              {/* Full-width Description */}
              <div style={{ width: "100%" }}>
                <strong>Description:</strong> {record.description || "—"}
              </div>

              {/* Two-column section for details */}
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  rowGap: 5,
                }}
              >
                <div style={{ flex: "1 1 45%" }}>
                  <strong>Tasks:</strong> {record.tasks}
                </div>

                <div style={{ flex: "1 1 45%" }}>
                  <strong>Start Date:</strong> {record.startDate || "—"}
                </div>

                <div style={{ flex: "1 1 45%" }}>
                  <strong>End Date:</strong> {record.endDate || "—"}
                </div>

                <div style={{ flex: "1 1 100%" }}>
                  <strong>Tags:</strong>{" "}
                  {record.tags && record.tags.length > 0 ? (
                    record.tags.map((tag) => (
                      <span
                        key={tag}
                        style={{
                          background: "#DBEAFE",
                          color: "#000",
                          padding: "4px 8px",
                          borderRadius: 4,
                          marginRight: 5,
                        }}
                      >
                        {tag.name}
                      </span>
                    ))
                  ) : (
                    <span>—</span>
                  )}
                </div>
              </div>
            </div>
          ),
          rowExpandable: () => true,
        }}
        className="custom-table"
        size="small"
      />
    </div>
  );
};

export default IterationsTableView;
